import useUrlSearchParams from 'hooks/useUrlSearchParams';

import { EDITOR_QUERY_PARAM } from './constants';
import { toBoolean } from './utils';

const useEditorOverride = (queryParam = EDITOR_QUERY_PARAM) => {
  const searchParams = useUrlSearchParams();

  return toBoolean(searchParams[queryParam]);
};

export default useEditorOverride;
